<template>
    <el-tabs type="border-card">
      <el-tab-pane label="充电订单">
        <recharge-order />
      </el-tab-pane>
      <el-tab-pane label="停车订单">
        <parking-order />
      </el-tab-pane>
    </el-tabs>
  </template>
  
  <script>
  import RechargeOrder from "@/views/StatisticsCentre/RechargeOrder";
  import ParkingOrder from "@/views/ParkingOrder/Index";
  
  export default {
    name: "UserManage",
    components: { RechargeOrder, ParkingOrder },
  };
  </script>
  
